import React, { Component } from 'react';
import { Alert, Button, Card, Dialog } from '@betareader/design-system';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Avatar from '../../../components/avatar/avatar';
import {
  fetchBlockedUsers,
  unblockUser,
} from '../../../modules/user';

export class BlockedUsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unblockingUserId: null,
      showUnblockConfirm: false,
    };
  }

  componentDidMount() {
    const { userProfile, idToken } = this.props;
    if (userProfile && userProfile._id && idToken) {
      this.props.fetchBlockedUsers(idToken, userProfile._id);
    }
  }

  componentDidUpdate(prevProps) {
    const { userProfile, idToken } = this.props;
    if (
      userProfile &&
      userProfile._id &&
      idToken &&
      (prevProps.userProfile?._id !== userProfile._id || prevProps.idToken !== idToken)
    ) {
      this.props.fetchBlockedUsers(idToken, userProfile._id);
    }
  }

  handleUnblockClick = userId => {
    this.setState({
      unblockingUserId: userId,
      showUnblockConfirm: true,
    });
  };

  handleUnblockConfirm = () => {
    const { unblockingUserId } = this.state;
    const { userProfile, idToken } = this.props;

    if (!unblockingUserId || !userProfile || !idToken) {
      return;
    }

    this.setState({ showUnblockConfirm: false });
    this.props.unblockUser(idToken, unblockingUserId, userProfile._id, () => {
      this.setState({ unblockingUserId: null });
    });
  };

  handleUnblockCancel = () => {
    this.setState({
      showUnblockConfirm: false,
      unblockingUserId: null,
    });
  };

  render() {
    const { blockedUsers, t, userProfile } = this.props;
    const { unblockingUserId, showUnblockConfirm } = this.state;

    if (!userProfile) {
      return null;
    }

    // Handle both array of IDs (strings) or array of user objects
    const blockedUserToUnblock = blockedUsers.find(user => {
      if (typeof user === 'string') {
        return user === unblockingUserId;
      }
      return user && (user._id === unblockingUserId || user === unblockingUserId);
    });
    // Get user ID for display/unblock action
    const getUserId = (user) => {
      if (typeof user === 'string') {
        return user;
      }
      return user && user._id;
    };
    // Get user display name
    const getUserDisplayName = (user) => {
      if (typeof user === 'string') {
        return user; // Just show the ID if we don't have user info
      }
      return user && (user.displayName || user.email || t('UnknownUser'));
    };

    return (
      <>
        <Card>
          <h2>{t('BlockedUsers')}</h2>
          {blockedUsers.length === 0 ? (
            <Alert>{t('NoBlockedUsers')}</Alert>
          ) : (
            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
              {blockedUsers.map((user, index) => {
                const userId = getUserId(user);
                const displayName = getUserDisplayName(user);
                const key = typeof user === 'string' ? user : (user._id || index);
                return (
                  <li key={key} style={{ alignItems: 'center', display: 'flex', gap: '1rem', justifyContent: 'space-between', padding: '0.75rem 0' }}>
                    <span style={{ alignItems: 'center', display: 'flex', gap: '0.75rem' }}>
                      <Avatar
                        name={displayName}
                        src={typeof user === 'object' ? user.photoUrl : undefined}
                        diameter={30}
                      />
                      {displayName}
                    </span>
                    <Button variant='danger' size='small' onClick={() => this.handleUnblockClick(userId)}>
                      {t('UnblockUser')}
                    </Button>
                  </li>
                );
              })}
            </ul>
          )}
        </Card>

        <Dialog
          open={showUnblockConfirm}
          title={t('UnblockUser')}
          onClose={this.handleUnblockCancel}
          actions={<>
            <Button variant='secondary' onClick={this.handleUnblockCancel}>{t('Cancel')}</Button>
            <Button variant='danger' onClick={this.handleUnblockConfirm}>{t('UnblockUser')}</Button>
          </>}
        >
          {t('UnblockUserConfirmation', {
            _name: blockedUserToUnblock ? getUserDisplayName(blockedUserToUnblock) : t('UnknownUser'),
          })}
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = state => ({
  userProfile: state.user.userProfile,
  idToken: state.user.idToken,
  blockedUsers: state.user.blockedUsers || [],
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchBlockedUsers,
      unblockUser,
    },
    dispatch
  );

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(BlockedUsersList)
);

